import { NotificationService } from "app/_services/notification.service";
import { Observable } from "rxjs";

// Utils.ts or a base component/service
export interface ApiObserver<T> {
    next?: (data: T) => void;
    error?: (err: any) => void;
    complete?: () => void;
    successMessage?: string;
    errorMessage?: string;
  }
  
  export function handleApiWithNotify<T>(
    observable: Observable<T>,
    observer: ApiObserver<T>,
    notify: NotificationService
  ): void {
    observable.subscribe({
      next: (data) => {
        observer.next?.(data);
        if (observer.successMessage) {
          notify.showSuccess(observer.successMessage);
        }
      },
      error: (err) => {
        observer.error?.(err);
        if (observer.errorMessage) {
          notify.showError(observer.errorMessage);
        }
      },
      complete: () => {
        observer.complete?.();
      }
    });
  }